import React from "react";
import { Form, Switch } from "antd";

interface ChangePasswordOnLoginProps {
  isEnabled?: boolean;
}

const ChangePasswordOnLogin: React.FC<ChangePasswordOnLoginProps> = () => {
  return (
    <Form.Item
      name={["systemUser", "forcePasswordChange"]}
      valuePropName="checked"
      label="Change password on login"
      layout="horizontal"
      colon={false}
    >
      <Switch />
    </Form.Item>
  );
};

export default ChangePasswordOnLogin;
